
import './styles/IM.css';
import {useEffect, useRef} from "react";
import {useRouter} from "react-router5";

function getIMScript(websocket_url,user) {
  const opts = {
    "authentication": "login",
    "allow_logout": false,
    "credentials_url": "/im_api/v1/get_credentials",
    "discover_connection_methods": false,
    "allow_bookmarks":false,
    "websocket_url":  websocket_url,
    "auto_login": true,
    "auto_away":  300,
    "i18n": "fr",
    "auto_reconnect": true,
    "message_archiving": "always",
    "view_mode": "embedded",
    "allow_non_roster_messaging": true,
    "locked_muc_nickname" : true,
    "muc_nickname_from_jid" : true,
    "nickname": user.firstname + " " + user.lastname,
    "allow_contact_removal": false,
    "assets_path": "/bo/vendor/conversejs/",
    "muc_domain":"conference.localhost",
    "locked_muc_domain":true,
    "clear_cache_on_logout":true,
    "notify_all_room_messages": true,
    "whitelisted_plugins": ["converse-altelis"],
    "roomconfig_whitelist":[],
    "muc_show_info_messages": [],
    "trusted": true,
    "muc_roomid_policy_hint":"Min. 3, Max. 40 caractères, en minuscules, sans espaces, caractères spéciaux autorisés : . _ -",
    "loglevel": "debug"
  };


  return `
    converse.initialize(${JSON.stringify(opts)});
  `
}

function getWebSocketURL() {
  // use the same protocol as the page hosting the script

  let websocket_url = window.location.protocol === "http:" ? "ws://" : "wss://";
  const hostname = window.location.hostname;
  const port = window.location.port;

  const use_reverse_proxy = ["reticular.fr", "altelis.com"];
	
  if (use_reverse_proxy.some(x => hostname.endsWith(x))) {
    websocket_url = [
      websocket_url, hostname, (port ? `:${port}` : ""), "/im/ws"
    ].join('')
  } else {
    websocket_url = websocket_url + `${hostname}:5443/ws`;
  }
  return websocket_url;
}

const importConverseJS = function(user) {
  const id = "converse-initialize"
  const s = document.getElementById(id)

  if (!s) {
    const websocket_url = getWebSocketURL();

    const script = document.createElement('script');
    script.id = id;
    script.innerHTML = getIMScript(websocket_url,user);
    script.async = false;
    document.body.appendChild(script);
  }
}

const IM = () => {
  const router = useRouter();
  const navigateToUrl = (router, url) => {
    const [id, type] = url.split('/').reverse();
    router.navigate(type, {id}, {reload: true})
  }

  const reticularLinkClick = (event) =>{
    const element = event.target;

    if (element.tagName.toLowerCase() === 'reticular-link') {
      const url = element.getAttribute('data-href');
      navigateToUrl(router, url)
    }
  }

  const insertConverse = (converse) => {
    conversejs = converse;
    document.addEventListener('click', reticularLinkClick);




    window._converse.reticular.forceRosterRefresh().then(()=>{
      window._converse.reticular.openLastChat();
      window._converse.api.settings.set('muc_roomid_policy',/^[a-z0-9._-]{5,40}$/);
      ref.current.appendChild(conversejs);
    });
  }

  const moveConverse = () =>{
    document.removeEventListener('click', reticularLinkClick);
    window._converse.reticular.closeChat();
    document.body.appendChild(conversejs);
  }

  function checkConverseLoad(mutationList){
    for(let mutation of mutationList){
      if(mutation.type === 'childList'){
        const conversejs = document.querySelector("#conversejs");
        const isInit = document.querySelector(".active-im #conversejs");
	    if(conversejs && isInit===null && window._converse.roster){
          insertConverse(conversejs);
        }
      }
    }
  }

  const ref = useRef(null);
  let conversejs = null;
  useEffect(() => {
      if (ref === null) return;
      conversejs = document.querySelector("#conversejs");
      const observer = new MutationObserver(checkConverseLoad);
      if(conversejs){
        insertConverse(conversejs);
      }else{
        observer.observe(document.body,{attributes:false,childList:true});
      }

      return () => {
        moveConverse();
        if(observer){
          observer.disconnect();
        }
      }
  }, [ref]);

  return <div id={'conversejsContainer'} className="active-im" ref={ref} />
}



export { importConverseJS };
export default IM;

